// migrated 1:1 from @nexato/nx-core-module, #688
import { CurrencyPipe, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Apollo, QueryRef } from 'apollo-angular';
import { Subscription, take } from 'rxjs';
import { Invoice } from '../../entities/payment/payment';
import { LoadingService } from '../../services/loading.service';
import { PaymentsService } from '../../services/payment/payment.service';
import { UsersService } from '../../services/users/users.service';
import * as fromGraphQl from './graphql';
import { ConnectedDevice } from '../../entities/connected-device/connected-device';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-uploader-state-view',
  templateUrl: './uploader-state-view.component.html',
  styleUrls: ['./uploader-state-view.component.scss']
})
export class UploaderStateViewComponent implements OnInit {

  public uploaders: ConnectedDevice[];
  public uploadersQuery: QueryRef<fromGraphQl.GetUploadersQueryResponse>;
  public uploadersQuerySubscription: Subscription;

  constructor(
    public paymentService: PaymentsService,
    public currencyPipe: CurrencyPipe,
    private apollo: Apollo,
    public loadingService: LoadingService,
    private datePipe: DatePipe,
    private translate: TranslateService
  ) {
  }

  ngOnInit(): void {
    this.subscribeToUploadersData();
  }

  downloadInvoice(url: string) {
    window.open(url, '_blank');
  }

  subscribeToUploadersData() {
    this.uploadersQuery = this.apollo.watchQuery<fromGraphQl.GetUploadersQueryResponse>({
      fetchPolicy: 'network-only',
      pollInterval: 10000,
      query: fromGraphQl.UPLOADERS_QUERY,
      variables: {
        type: "UPLOADER",
      },
    })
    this.uploadersQuerySubscription = this.uploadersQuery.valueChanges.subscribe( (data) => {
      if (data && data.data && data.data.getUploaders) {
        this.uploaders = data.data.getUploaders.map((uploader) => new ConnectedDevice(uploader));
      } else {
        this.uploaders = undefined;
      }
    });
  }

  calculateHealthStatus(uploader: ConnectedDevice): string {
    if (!uploader || !uploader.lastSeenDateTime) {
      return 'unknown';
    }

    const lastSeen = new Date(uploader.lastSeenDateTime);
    const now = new Date();
    const diffInMinutes = (now.getTime() - lastSeen.getTime()) / (1000 * 60);

    if (diffInMinutes < 6) {
      return 'coreModule.uploaderStateViewComponent.healtStatus.online';
    } else if (diffInMinutes < 12) {
      return 'coreModule.uploaderStateViewComponent.healtStatus.unstable';
    } else {
      return 'coreModule.uploaderStateViewComponent.healtStatus.offline';
    }
  }

  calculateSeverity(status: string) {
    switch (status) {
      case 'coreModule.uploaderStateViewComponent.healtStatus.offline':
        return 'info';
      case 'coreModule.uploaderStateViewComponent.healtStatus.unstable':
        return 'danger';
      case 'coreModule.uploaderStateViewComponent.healtStatus.online':
        return 'success';
    }
    return 'danger';
  }

  getTooltip(uploader: ConnectedDevice): string {
    const lastSeen = new Date(uploader.lastSeenDateTime);
    let label = this.translate.instant('coreModule.uploaderStateViewComponent.tooltip.lastSeen');
    return `Last seen: ${this.datePipe.transform(lastSeen, 'dd.MM.yyyy HH:mm')}`;
  }


}
